module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "gPageBorder",
    attrs: {
      "id": ""
    }
  }, [_c('tyc', {
    attrs: {
      "tqobj": _vm.tqobj
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('app_tip'),
      "visible": _vm.cerDialogVisible,
      "size": "tiny",
      "before-close": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.cerDialogVisible = $event
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.cerTipMsg))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.cerDialogVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.pushUploadCer
    }
  }, [_vm._v(_vm._s(_vm.$t('app_uploadCer')))])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('app_tip'),
      "visible": _vm.cerTipDialogVisible,
      "size": "tiny",
      "before-close": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.cerTipDialogVisible = $event
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.cerTipMsg))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.cerTipDialogVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_sure')))])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_addPush'),
      "size": "middle"
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.dvLoading),
      expression: "dvLoading"
    }]
  }, [_c('div', {
    staticClass: "gDiaTable",
    staticStyle: {
      "width": "100%",
      "background": "none",
      "text-align": "left"
    }
  }, [_c('span', [_c('el-select', {
    staticStyle: {
      "width": "16%",
      "margin-right": "10px"
    },
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_distributor')
    },
    on: {
      "change": _vm.selectDvChange
    },
    model: {
      value: (_vm.channelId),
      callback: function($$v) {
        _vm.channelId = $$v
      },
      expression: "channelId"
    }
  }, _vm._l((_vm.channels), function(item) {
    return _c('el-option', {
      key: item.mechanismid,
      attrs: {
        "label": item.mechanismname,
        "value": item.mechanismid
      }
    })
  }))], 1), _vm._v(" "), _c('span', [_c('el-select', {
    staticStyle: {
      "width": "16%",
      "margin-right": "10px"
    },
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_status')
    },
    on: {
      "change": _vm.selectDvChange
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  }, _vm._l((_vm.stModel), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.label,
        "value": item.vl
      }
    })
  }))], 1), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "40%",
      "margin-bottom": "10px"
    },
    attrs: {
      "placeholder": _vm.$t('app_searchTerminal'),
      "icon": "search"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.srchDevice($event)
      }
    },
    model: {
      value: (_vm.srchValue),
      callback: function($$v) {
        _vm.srchValue = $$v
      },
      expression: "srchValue"
    }
  })], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.dvTableData,
      "border": "",
      "tooltip-effect": "dark"
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "terminalName",
      "label": _vm.$t('app_terName'),
      "width": "130"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "mechName",
      "label": _vm.$t('app_distributor'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "terminal_status",
      "align": "center",
      "label": _vm.$t('app_status'),
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.terminalStatus == 1) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_online')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 2) ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_offline')))]) : _vm._e(), _vm._v(" "), (scope.row.terminalStatus == 0) ? _c('el-tag', {
          attrs: {
            "type": "gray",
            "size": "mini"
          }
        }, [_vm._v(_vm._s(_vm.$t('app_new')))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operate",
      "label": _vm.$t('app_operate'),
      "align": "right",
      "header-align": "center",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_push'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.bindOperate(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-upload"
        })])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.dvIndex,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.dvTotal
    },
    on: {
      "current-change": _vm.pageDvSelect,
      "size-change": _vm.pageDvSized
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('div', {}, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-button', {
    staticClass: "gSgLeftBtn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.jumpToUpload
    }
  }, [_vm._v(_vm._s(_vm.$t('app_addfile')))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_filetype')
    },
    on: {
      "change": _vm.fileTypeChange
    },
    model: {
      value: (_vm.ftype),
      callback: function($$v) {
        _vm.ftype = $$v
      },
      expression: "ftype"
    }
  }, _vm._l((_vm.ftypes), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.lb,
        "value": item.vl
      }
    })
  }))], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('app_subtype')
    },
    on: {
      "change": function($event) {
        _vm.getList()
      }
    },
    model: {
      value: (_vm.sftype),
      callback: function($$v) {
        _vm.sftype = $$v
      },
      expression: "sftype"
    }
  }, _vm._l((_vm.cmsts), function(item) {
    return _c('el-option', {
      key: item.vl,
      attrs: {
        "label": item.lb,
        "value": item.vl
      }
    })
  }))], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_name'),
      "icon": "search",
      "on-icon-click": _vm.query
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.query($event)
      }
    },
    model: {
      value: (_vm.queryKey),
      callback: function($$v) {
        _vm.queryKey = $$v
      },
      expression: "queryKey"
    }
  })], 1)])], 1)], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('el-table', {
    staticClass: "tbPoint gTopMg",
    staticStyle: {
      "width": "100%",
      "border": "none"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    },
    on: {
      "row-click": _vm.cellClick,
      "sort-change": _vm.sortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "sortable": "custom",
      "prop": "fileName",
      "label": _vm.$t('app_filename'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "fileVersion",
      "width": "",
      "label": _vm.$t('app_version')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "fileType",
      "formatter": _vm.setft,
      "width": "115",
      "label": _vm.$t('app_filetype')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "subFileType",
      "formatter": _vm.setsbt,
      "width": "120",
      "label": _vm.$t('app_subtype')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "mechName",
      "width": "",
      "label": _vm.$t('app_distributor')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "fileStatus",
      "width": "115",
      "label": _vm.$t('app_vStatus')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', {
          style: (_vm.getStatus(scope.row.fileStatus).style)
        }, [_vm._v(_vm._s(_vm.getStatus(scope.row.fileStatus).vl))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "createTime",
      "sortable": "custom",
      "width": "175",
      "label": _vm.$t('app_addtime')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "right",
      "prop": "operate",
      "width": "122",
      "label": _vm.$t('app_operate')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "background": "none"
          }
        }, [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('lin_btn.send'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.fileStatus == 2),
            expression: "scope.row.fileStatus == 2"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.pushApp(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-upload"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_edit'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: ((scope.row.fileStatus != '1' && scope.row.fileStatus != '2')),
            expression: "(scope.row.fileStatus != '1' && scope.row.fileStatus != '2') "
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.editApp(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_down'),
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.downOldApp(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-download"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_smVerify'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.fileStatus != '1' && scope.row.fileStatus != '2'),
            expression: "scope.row.fileStatus != '1' && scope.row.fileStatus != '2' "
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.submitApp(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-external-link-square"
        })])], 1), _vm._v(" "), _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (true),
            expression: "true"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.deleteApp(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-o",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.index,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "current-change": _vm.pageSelect,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4169cba0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/system/file/list.vue
// module id = 1024
// module chunks = 0